import * as React from "react";
import { Dialog, DialogContent } from "@material-ui/core";
import { FileGrid } from "../../../src/Components/FileGrid";

export const AircraftUtilizationFilePopup = props => {
  const [open, setOpen] = React.useState(props.open);

  React.useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  const handleClose = () => {
    setOpen(false);
    props?.handleClose?.();
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={open}
        onClose={handleClose}
        aria-labelledby="max-width-dialog-title"
      >
        <DialogContent>
          <FileGrid
            source="aircraftutilizationfilerelations"
            filter={{ aircraftUtilizationId__eq: props?.aircraftUtilizationDetail.id }}
            canRemove={true}
            showFileType={false}
            triggeted={() => {}}
          />
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default AircraftUtilizationFilePopup;
